import CityPage from '../../components/CityPage';

const cityData = {
    name: "Villers-sur-Mer",
    slug: "villers-sur-mer",
    postalCode: "14640",
    intro: "CC Débarras 14 assure des débarras professionnels à Villers-sur-Mer. Maisons en bord de mer, résidences secondaires, appartements de famille : nous intervenons pour tous types de biens sur la commune. Succession, vente, départ en retraite ou simple remise en ordre — notre équipe prend en charge le tri, l'enlèvement et l'évacuation, rapidement et avec discrétion.",
    nearby: ["Blonville-sur-Mer", "Auberville", "Houlgate", "Dives-sur-Mer", "Bénerville-sur-Mer"],
};

const VillersSurMer = () => <CityPage city={cityData} />;

export default VillersSurMer;
